import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { MetadataConfigAPI } from "../api/metadata-config";
import type { MetadataField } from "../types";

const METADATA_CONFIG_KEY = "metadata-config";

export const useMetadataConfig = () => {
  const { company: clientId } = useParams<{ company: string }>();

  return useQuery({
    queryKey: [METADATA_CONFIG_KEY, clientId],
    queryFn: () => MetadataConfigAPI.getConfig(clientId!),
    enabled: !!clientId,
  });
};

export const useUpdateMetadataConfig = () => {
  const { company: clientId } = useParams<{ company: string }>();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (fields: MetadataField[]) =>
      MetadataConfigAPI.updateConfig(clientId!, fields),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [METADATA_CONFIG_KEY, clientId],
      });
    },
  });
};
